import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthFormModal from "./AuthFormModal";
import { ROUTES, TOKEN_KEY } from "../common/constants";
import { clearPostLoginRedirect, takePostLoginRedirect } from "../common/postLoginRedirect";

// Standalone sign-in route so emailed invites can link straight to the
// Google/Microsoft buttons instead of dropping people on the landing page.
const SignInPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem(TOKEN_KEY)) {
      // Already signed in: honour an email link's destination if one is parked,
      // otherwise the dashboard.
      navigate(takePostLoginRedirect() || ROUTES.DASHBOARD, { replace: true });
    }
  }, [navigate]);

  return (
    <AuthFormModal
      onCancel={() => {
        clearPostLoginRedirect();
        navigate(ROUTES.LANDING);
      }}
    />
  );
};

export default SignInPage;
